import { useCallback, useEffect, useState } from "react";
import axiosClient from "@/config/api/axios";
import { MODELS } from "@/config/api/endpoints";
import {
  HOME_AI_MODEL_SELECT_OPTIONS,
  SPECIFIC_MODEL_OPTIONS,
} from "./homeAiModelSelectOptions";

export function useAiModelCatalog() {
  const [catalog, setCatalog] = useState({
    tiers: HOME_AI_MODEL_SELECT_OPTIONS,
    models: SPECIFIC_MODEL_OPTIONS,
  });
  const refresh = useCallback(() => {
    axiosClient
      .get(MODELS)
      .then(({ data }) => {
        if (!Array.isArray(data?.models)) return;
        const byId = new Map(data.models.map((model) => [model.id, model]));
        setCatalog({
          models: data.models.map((model) => ({ ...model, value: model.id })),
          tiers: [
            HOME_AI_MODEL_SELECT_OPTIONS[0],
            ...(data.tiers ?? []).map((tier) => ({
              value: tier.model,
              label: tier.label,
              description: tier.description,
              costTier: tier.cost_tier,
              ...byId.get(tier.model),
            })),
          ],
        });
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...catalog, refresh };
}
